export default __webpack_public_path__ + "images/next_5828fe.svg";